export default {
  title: 'Tilføjelser for større succes',
  description: 'Opgrader dit abonnement med ekstra funktioner',
  buttons: {
    continue: 'Fortsæt',
    no_app_for_now: 'Ingen mobilapp for nu',
  },
  toasts: {
    something_went_wrong: 'Noget gik galt. Prøv at opdatere siden, eller kontakt teknisk support!',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes. Kontakt teknisk support!',
    changes_got_saved: 'Ændringerne blev gemt!',
  },
};
